import React from "react";
import Banner from "../components/affiliate/Banner";
import {
  Heading,
  Text,
  SimpleGrid,
  Box,
  Image,
  Stack,
  Button,
  Flex,
} from "@chakra-ui/react";
import CommonContainer from "../components/shared/CommonContainer";
import BenefitsSection from "../components/affiliate/BenefitsSection";
import SpecialPromotion from "../components/affiliate/SpecialPromotion";
import OpportunityBox from "../components/affiliate/OpportunityBox";

export default function AffiliatePage() {
  return (
    <>
      <Banner />
      <CommonContainer>
        <Stack alignItems="center" my={10}>
          <Heading
            fontWeight={"semibold"}
            fontSize={{ base: "24px", md: "31px" }}
            py={10}
            textAlign="center"
          >
            You Choose Your Commission Plan
          </Heading>
          <SimpleGrid
            columns={{ base: 1, md: 2, xl: 3 }}
            gap={{ base: 20 }}
            // width=""
            py={{ md: 10 }}
          >
            {howItWorksData.map((item,index) => (
              <Stack alignItems="center" bg={"#008DDB08"} p={10} key={index}>
                <Box height={{ md: "80px" }}>
                  <Image src={item.imageUrl} />
                </Box>
                <Heading
                  fontWeight={"semibold"}
                  fontSize={{ base: "20px", xl: "27px" }}
                  textAlign="center"
                >
                  {item.title}
                </Heading>
                <Text
                  color={"#727272"}
                  maxW="80%"
                  fontSize={{ base: "19px", xl: "24px" }}
                  fontWeight={"medium"}
                  align="center"
                >
                  {item.description}
                </Text>
              </Stack>
            ))}
          </SimpleGrid>
          <Button bg="brand.500" color="white" px={6}>
            Join now
          </Button>
        </Stack>
      </CommonContainer>
      <BenefitsSection />
      <CommonContainer>
        <SpecialPromotion />
      </CommonContainer>
      <Flex bg="#F7F7F7" py={{ base: 10, md: 20 }}>
        <CommonContainer>
          <Stack gap={10}>
            <Heading align="center">Don't Miss Out This Opportunity!</Heading>
            <SimpleGrid
              columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }}
              gap={{ base: 8, xl: 16 }}
              w="full"
            >
              {opportunityData.map((item,index) => {
                return (
                  <OpportunityBox
                    title={item.title}
                    description={item.description}
                    key={index}
                  />
                );
              })}
            </SimpleGrid>
          </Stack>
        </CommonContainer>
      </Flex>
      <Stack alignItems={"center"} gap={4} my={{ base: 10, md: 20 }}>
        <Text
          color="#727272"
          mb={4}
          fontSize={{ base: "18px", md: "21px" }}
          fontWeight="semibold"
          textAlign="center"
          w="90%"
        >
          Interested in Becoming a Decolance Affiliate?
        </Text>
        <Button bg="brand.500" color="white" px={8} py={6}>
          Get Started
        </Button>
      </Stack>
    </>
  );
}
const howItWorksData = [
  {
    title: "Join as an Affiliate",
    description:
      "It’s free to get started. Access marketing materials, tools, and more!",
    imageUrl: "/images/affiliate/join.png",
  },
  {
    title: "Promote Decolance",
    description:
      "Share Fiverr with your target audience. There's a match for every need.",
    imageUrl: "/images/affiliate/promote.png",
  },
  {
    title: "Start Earning",
    description:
      "Earn right from the moment your traffic converts. Check out our commission plan.",
    imageUrl: "/images/affiliate/earning.png",
  },
];
const opportunityData = [
  {
    title: "We’re known",
    description: "Over 5.5M people use Fiverr to start & grow their businesses",
  },
  {
    title: "We’re popular",
    description: "Over 5.5M people use Fiverr to start & grow their businesses",
  },
  {
    title: "We’re everywhere",
    description: "We operate in over 160 countries",
  },
  {
    title: "We’re known",
    description: "Over 5.5M people use Fiverr to start & grow their businesses",
  },
];
